import { Component, OnInit } from '@angular/core'
import { environment } from 'src/environments/environment'
import {
  FormControl,
  FormGroup,
  FormArray,
  FormBuilder,
  Validators
} from '@angular/forms'
import { Observable } from 'rxjs'
import { SelectionModel } from '@angular/cdk/collections'
import { ModulesService } from '../../modules.service'
import { HttpService } from 'src/app/core/services/http.service'
import { MatDialog } from '@angular/material'
import { SnackbarService } from 'src/app/snackbar.service'
import { map, debounceTime } from 'rxjs/operators'
import { BarcodeScannerComponent } from '../../sales/out-for-delivery/barcode-scanner/barcode-scanner.component'
import { LoadingDialogBoxComponent } from '../../process/process-records/loading-dialog-box-component/loading-dialog-box-component.component'

@Component({
  selector: 'app-out-for-pickup',
  templateUrl: './out-for-pickup.component.html',
  styleUrls: ['./out-for-pickup.component.css']
})
export class OutForPickupComponent implements OnInit {
  isAllItemsSelected = true
  checked
  baseUrl = environment.baseURL
  orderId
  open: boolean = false
  orderIdControl: FormControl
  orderItems$: Observable<any>
  orderItems: Array<any>
  driverForm: FormGroup
  itemBarcodeArray: Array<any> = []
  selectedOptions
  itemsForm: FormGroup
  barcode: FormControl
  barcodeArray = []
  orderDetailsForm: FormArray
  selection = new SelectionModel<any>(true, [])
  openScanner: boolean = false
  currentBarcodeIndex
  barcodeItemIndex: any
  barcodePkgItemIndex: any
  transporterName = ''
  driverNumber = ''
  vehicleOptions: Observable<any>
  filteredVehicles: Observable<any>
  driverOptions: Observable<any>
  filteredDrivers: Observable<any>
  helper = 0
  recordId: string
  totalItems = 0

  constructor(
    private fb: FormBuilder,
    private modulesService: ModulesService,
    private httpService: HttpService,
    public dialog: MatDialog,
    private _snackbar: SnackbarService
  ) {}

  ngOnInit() {
    this.orderIdControl = this.fb.control('')
    this.driverForm = this.fb.group({
      transporterName: this.fb.control('', Validators.required),
      vehicleNumber: this.fb.control('', Validators.required),
      driverName: this.fb.control('', Validators.required),
      driverNumber: this.fb.control('', Validators.required),
      helpers: this.fb.array([])
    })

    this.filteredVehicles = this.httpService
      .post(
        `${this.baseUrl}/records/${environment.config.shipment.vehicle}/list`
      )
      .pipe(
        map(data => {
          return data.map(elem => {
            return {
              name: elem.details[0][0].name,
              vehicleNumber: elem.details[0][0].vehicleNumber
            }
          })
        })
      )

    this.driverForm
      .get('vehicleNumber')
      .valueChanges.pipe(
        debounceTime(500),
        map(value => {
          if (value) {
            let body = {
              filters: [{ vehicleNumber: value }]
            }
            this.filteredVehicles = this.httpService
              .post(
                `${this.baseUrl}/records/${environment.config.shipment.vehicle}/list`,
                body
              )
              .pipe(
                map(data => {
                  return data.map(elem => {
                    return {
                      name: elem.details[0][0].name,
                      vehicleNumber: elem.details[0][0].vehicleNumber
                    }
                  })
                })
              )
            // this.filteredVehicles.subscribe(vehicle => {
            // 	if (vehicle.length) {
            // 		this.driverForm.get('transporterName').patchValue(vehicle.transporterName);
            // 	}
            // 	else {
            // 		this.driverForm.get('transporterName').patchValue('');
            // 	}
            // }
            // )
          } else {
            this.filteredVehicles = this.httpService
              .post(
                `${this.baseUrl}/records/${environment.config.shipment.vehicle}/list`
              )
              .pipe(
                map(data => {
                  return data.map(elem => {
                    return {
                      name: elem.details[0][0].name,
                      vehicleNumber: elem.details[0][0].vehicleNumber
                    }
                  })
                })
              )
          }
        })
      )
      .subscribe()

    this.filteredDrivers = this.httpService
      .post(
        `${this.baseUrl}/records/${environment.config.shipment.driver}/list`
      )
      .pipe(
        map(data => {
          return data.map(elem => {
            return {
              name: elem.details[0][0].name,
              phone: elem.details[0][0].phone,
              _id: elem._id
            }
          })
        })
      )

    this.driverForm
      .get('driverName')
      .valueChanges.pipe(
        debounceTime(500),
        map(value => {
          if (value) {
            let body = {
              filters: [{ name: value }]
            }
            this.filteredDrivers = this.httpService
              .post(
                `${this.baseUrl}/records/${environment.config.shipment.driver}/list`,
                body
              )
              .pipe(
                map(data => {
                  return data.map(elem => {
                    return {
                      name: elem.details[0][0].name,
                      phone: elem.details[0][0].phone,
                      _id: elem._id
                    }
                  })
                })
              )
            // this.filteredDrivers.subscribe(driver => {
            // 	debugger;
            // 	if (driver.length) {
            // 		this.driverForm.get('driverNumber').patchValue(driver.phone);
            // 	}
            // 	else {
            // 		this.driverForm.get('driverNumber').patchValue('');
            // 	}
            // }
            // )
          } else {
            this.filteredDrivers = this.httpService
              .post(
                `${this.baseUrl}/records/${environment.config.shipment.driver}/list`
              )
              .pipe(
                map(data => {
                  return data.map(elem => {
                    return {
                      name: elem.details[0][0].name,
                      phone: elem.details[0][0].phone,
                      driverNumber: elem.details[0][0].driverNumber,
                      _id: elem._id
                    }
                  })
                })
              )
          }
        })
      )
      .subscribe()
  }

  submitForm() {
    this.orderId = this.orderIdControl.value
    this.selection.clear()
    if (!this.orderId.includes('-')) {
      this._snackbar.showSnackbar('Type pickup id instead of order id', 'error')
      return
    }
    this.orderItems$ = this.modulesService.pickupitemsbyPickupId(this.orderId)
    this.orderItems$.subscribe(data => {
      if (data.status != 'plannedForPickup') {
        this.open = false
        this._snackbar.showSnackbar(
          'This order id has not been planned for picked up.',
          'error'
        )
        return
      }
      this.open = true
      this.orderItems = data.items
      this.recordId = data.recordId
      this.orderItems = this.orderItems
        .filter(item => item.status == 'initiated')
        .map(item => {
          let pkg
          if (item.packageItems) {
            pkg = item.packageItems.map(pkgItem => {
              return {
                _id: item._id,
                ...pkgItem
              }
            })
          }
          if (item.metaInfo && item.metaInfo.barcode) {
            return {
              ...item,
              packageItems: pkg,
              barcode: item.metaInfo.barcode
            }
          } else
            return {
              ...item,
              packageItems: pkg,
              barcode: ''
            }
        })

      this.orderItems.forEach(item => {
        this.totalItems = this.totalItems + 1
        if (item.packageItems) {
          this.totalItems = this.totalItems + item.packageItems.length
        }
      })
      this.orderItems.forEach(node => {
        this.selection.select(node)
        if (node.packageItems) {
          node.packageItems.forEach(sub => this.selection.select(sub))
        }
      })
    })
  }

  onCheckboxClicked(event) {
    if (event.checked) {
      this.isAllItemsSelected = true
      this.orderItems.forEach(elem => {
        this.selection.select(elem)
        if (elem.packageItems) {
          elem.packageItems.forEach(subNode => {
            this.selection.select(subNode)
          })
        }
      })
    } else {
      this.isAllItemsSelected = false
      this.selection.clear()
    }
  }

  masterToggle(node, item = undefined) {
    this.selection.toggle(node)
    if (node.packageItems) {
      if (this.selection.isSelected(node)) {
        node.packageItems.forEach(subNode => {
          this.selection.select(subNode)
        })
      } else {
        node.packageItems.forEach(subNode => {
          this.selection.deselect(subNode)
        })
      }
    }
    if (item) {
      let allChildSelected = item.packageItems.every(elem =>
        this.selection.isSelected(elem)
      )
      if (allChildSelected) {
        this.selection.select(item)
      } else {
        this.selection.deselect(item)
      }
    }
    this.isAllItemsSelected = this.orderItems.every(elem =>
      this.selection.isSelected(elem)
    )
  }

  openScannerEvent(i, j = undefined) {
    this.openScanner = false
    this.openScanner = true
    let dialogRef = this.dialog.open(BarcodeScannerComponent, {
      width: '70%'
    })
    dialogRef.componentInstance.result.subscribe(resultString => {
      this.dialog.closeAll()
      if (j == undefined) {
        this.orderItems[i].barcode = resultString
      } else {
        this.orderItems[i].packageItems[j].barcode = resultString
      }
    })
  }

  barcodeChanged(barcode, itemIndex, pkgitemIndex = undefined) {
    if (pkgitemIndex >= 0) {
      this.orderItems[itemIndex].packageItems[pkgitemIndex].barcode = barcode
    } else {
      this.orderItems[itemIndex].barcode = barcode
    }
  }

  addHelper() {
    let form = this.fb.group({
      helperName: this.fb.control(''),
      helperNumber: this.fb.control('')
    })
    ;(<FormArray>this.driverForm.get('helpers')).push(form)
  }

  removeHelper(event, index) {
    ;(<FormArray>this.driverForm.get('helpers')).controls.splice(index, 1)
    ;(<FormArray>this.driverForm.get('helpers')).value.splice(index, 1)
  }

  submitPickupDetails() {
    const body = {}
    let items = []
    this.orderItems.forEach(item => {
      if (item.type === 'package') {
        let childIds = this.selection.selected.filter(
          elem => elem._id === item._id && elem.productId
        )
        if (childIds.length) {
          childIds = childIds.map(child => {
            return {
              productId: child.productId,
              barcode: child.barcode,
              name: child.name
            }
          })
          items.push({
            _id: item.itemId,
            type: 'package',
            barcode: childIds,
            name: item.name
          })
        }
      } else {
        let elem = this.selection.selected.find(
          selectedItem => selectedItem._id === item._id
        )
        if (elem) {
          items.push({
            _id: item.itemId,
            type: 'simple',
            barcode: item.barcode,
            name: item.name
          })
        }
      }
    })
    body['itemInfo'] = items
    body['type'] = 'pickup'
    body['reference'] = this.orderId
    let form = this.driverForm.value
    form.helpers = form.helpers.map(helper => {
      return {
        ...helper,
        helperName: helper.helperName.name
      }
    })
    body['shipmentInfo'] = {
      driverName: form.driverName.name,
      driverNumber: form.driverNumber,
      helpers: form.helpers,
      transporterName: form.transporterName,
      vehicleNumber: form.vehicleNumber.vehicleNumber,
      _id: form.driverName._id
    }
    body['orderId'] = this.orderId
    body['processId'] = environment.config.collections.pickup
    body['recordId'] = this.recordId

    this.openDialog()
    this.httpService
      .post(`${this.baseUrl}/dept/collections/outforpickup`, body)
      .subscribe(
        data => {
          this.dialog.closeAll()
          this._snackbar.showSnackbar(data.msg, 'success')
          this.open = false
          this.orderIdControl.setValue('')
          this.driverForm.reset()
        },
        error => {
          this.dialog.closeAll()
          this._snackbar.showSnackbar(error.msg, 'error')
        }
      )
  }

  openDialog() {
    const dialogRef = this.dialog.open(LoadingDialogBoxComponent, {
      disableClose: true,
      panelClass: 'loadingDialog'
    })
  }

  displayFn(option): string {
    return option && option.name ? option.name : ''
  }

  displayFnVehicle(option): string {
    return option && option.vehicleNumber ? option.vehicleNumber : ''
  }

  vehicleSelected(value) {
    this.driverForm.get('transporterName').patchValue(value.name)
  }

  driverSelected(value) {
    this.driverForm.get('driverNumber').patchValue(value.phone)
  }
}
